import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5386048"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "esim-error-payment" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "success-payment__title" }, "Thank you", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "success-payment__description" }, "The payment was successful", -1))
const _hoisted_4 = {
  key: 0,
  class: "mt-5",
  style: {"display":"flex","align-items":"center","color":"#330fbd","font-size":"20px","gap":"10px"}
}

import SuccessIcon from "@/components/icons/SuccessIcon.vue";
import { useUserStore } from "@/stores/user";
import router from "@/router";
import { ref, Ref, onBeforeUnmount } from "vue";
import { useAppStore } from "@/stores/app";
import { useDataStore } from "@/stores/data";
import { Transaction } from "@/stores/esim";
import InfoIcon from "@/components/icons/InfoIcon.vue";
import PopupCashbackInfo from "@/components/popups/PopupCashbackInfo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessPayment',
  props: {
  transaction: Transaction,
},
  setup(__props) {



const userStore = useUserStore();
const appStore = useAppStore();
const dataStore = useDataStore();

const goEsims = () => {
  if (!userStore.isAuth) {
    router.push({ name: `${router.currentRoute.value.name}#auth` });
  } else {
    router.push("/profile");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SuccessIcon, { class: "success-payment__icon" }),
    _hoisted_2,
    _hoisted_3,
    (_unref(dataStore).cashbackEnabled && _unref(dataStore).cashbackMaxPercent)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createTextVNode(" You just earned $" + _toDisplayString((
          Math.round(__props.transaction.amount * _unref(dataStore).cashbackMaxPercent) / 100
        ).toLocaleString("en-US")) + " in rewards ", 1),
          _createElementVNode("button", {
            class: "info-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).showPopup({ component: PopupCashbackInfo })))
          }, [
            _createVNode(InfoIcon, { class: "info-button__icon" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn btn-b btn-max btn-danger success-payment__button mt-4",
      onClick: goEsims
    }, " Show my ESIMs ")
  ]))
}
}

})